var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"mt-4",attrs:{"justify":"center"}},[_c('v-col',{attrs:{"cols":"12"}},[_c('span',{staticClass:"text-h5 grey--text"},[_vm._v("Stampa")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }